import * as yup from "yup";
import { t } from "@/i18n-js/instance";

export const CREATE_CUSTOM_THEME_FORM_VALIDATION_SCHEMA = yup.object({
  theme_name: yup
    .string()
    .required(
      t(
        "builder_ui.theme_configuration.rename_custom_theme_modal.form.name.required",
      ),
    ),
});
